import { CommonModule } from '@angular/common';
import { ModalBaseModule } from 'NewAngular/features/components/modals/modal-base/modal-base.module';
import * as i0 from "@angular/core";
export class ConvertModalModule {
}
ConvertModalModule.ɵfac = function ConvertModalModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ConvertModalModule)(); };
ConvertModalModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ConvertModalModule });
ConvertModalModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule, ModalBaseModule] });
